const html = require('choo/html');

const progressBarStyles = 'progress-bar w-100 bg-dark-gray dib';
const progressStyles = 'bg-dt-white bw1 h0_5 part';
function view(state) {
  const trueProgress = state.quiztaker.progress;
  const fakeProgress =
    trueProgress > state.questions.length ? trueProgress - 1 : trueProgress;

  const progress = (fakeProgress / state.questions.length) * 100;

  return html`
    <div>
      <div class="bg-navy pv2 ph3">
        <div class="${progressBarStyles}">
          <div
            class="progress-indicator ${progressStyles}"
            style="width: ${progress}%"
          ></div>
        </div>
        <div class="flex ttu justify-between white f6">
          <span class="ti-sans-b">Question ${fakeProgress}</span
          ><span>${state.questions.length} Total</span>
        </div>
      </div>
    </div>
  `;
}

module.exports = view;
